import Body from './components/layout/Body';
import { Provider } from 'react-redux';
import appStore from './store';

function App() {
  return (
    <Provider store={appStore}>
      <Body />
    </Provider>
  );
}

export default App;
